// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ABSH","label":"Section_label__20_Q_","contentWrap":"Section_contentWrap__1ErIN","footer":"Section_footer__1C1hy","footerInner":"Section_footerInner__2lyOi"};